
export default {
  name: 'MediaBar',
  props: {
    selected: {
      type: String,
      default: '',
    },
    disabled: {
      type: Array,
      default: () => [],
    },
    displayed: {
      type: Array,
      default: () => ['image', 'emoji', 'gif', 'bold', 'bullet', 'poll'],
    },
    allowPolls: {
      type: Boolean,
      default: false,
    },
    allowAdditionalFormatting: {
      type: Boolean,
      default: false,
    },
    gap: {
      type: String,
      default: '2',
    },
  },
  computed: {
    gapClass() {
      return `gap-${this.gap}`;
    },
  },
};
